import Vue from 'vue';
import moment from "moment";

export const FILTERS = {
    firstLetter: (text) => {
        if (text) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }
    },
    numberFormat: (number) => {
        if (number) {
            return `${number}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
    },
    upper: (str) => {
        if (str) {
            return str.toUpperCase();
        }
    },
    unixDate: (unix) => {
        if (unix) {
            return moment.unix(unix).format("MM/DD/YYYY");
        }
    },
    date: (date, format = "YYYY-MM-DD") => {
        if (date) {
            return moment(date).format(format);
        }
    },
    toPercentage: (number, decimal = 2) => {
        if (number) {
            return number.toFixed(decimal)
        }
    }
}

export const registeredFilters = function () {
    Object.keys(FILTERS).forEach(key => {
        Vue.filter(key, FILTERS[key]);
    })
}
